(() => {
  if (window.NKDHotfix20260630) return;
  window.NKDHotfix20260630 = true;

  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const currentVariantId = (form) => {
    const idInput = form?.querySelector('[name="id"]');
    return idInput?.value || '';
  };

  const initHeaderScroll = () => {
    const update = () => {
      document.body.classList.toggle('nkd-header-scrolled', window.scrollY > 4);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  };

  const initTopline = () => {
    const key = 'nkdToplineClosed20260630';
    const close = document.querySelector('[data-nkd-topline-close]');

    try {
      if (window.localStorage.getItem(key) === 'true') {
        document.body.classList.add('nkd-topline-hidden');
      }
    } catch {
      /* Ignore storage failures in private browsing modes. */
    }

    if (!close) return;
    close.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.add('nkd-topline-hidden');
      try {
        window.localStorage.setItem(key, 'true');
      } catch {
        /* Ignore storage failures in private browsing modes. */
      }
    });
  };

  const selectedPrice = (panel) => {
    return panel?.querySelector('.nkd-pdp__price')?.textContent.trim() || '';
  };

  const readVariants = (panel) => {
    const source = panel?.querySelector('[data-nkd-variants]');
    if (!source) return [];
    try {
      return JSON.parse(source.textContent).filter(Boolean);
    } catch {
      return [];
    }
  };

  const openMobileBuy = (form, variant) => {
    form.classList.add('is-size-open');
    if (variant) updateMobileBuy(form, variant, false);
  };

  const updateMobileBuy = (form, variant, selected) => {
    const input = form.querySelector('[data-nkd-mobile-variant-input]');
    const submit = form.querySelector('.nkd-mobile-buy__submit');
    const label = form.querySelector('[data-nkd-mobile-label]');
    const requiresSelection = form.dataset.nkdMobileRequiresSelection === 'true';
    const hasSelection = selected || !requiresSelection;

    form.querySelectorAll('[data-nkd-mobile-variant-id]').forEach((button) => {
      button.classList.toggle('is-selected', hasSelection && button.dataset.nkdMobileVariantId === String(variant?.id || ''));
    });

    form.classList.toggle('is-size-selected', hasSelection);
    if (hasSelection) form.classList.add('is-size-open');
    if (input) input.value = hasSelection && variant ? variant.id : '';
    if (label) label.textContent = hasSelection && variant ? `Selected size: ${variant.title}` : 'Select size';
    if (submit) {
      submit.disabled = !hasSelection || !variant || variant.available === false;
      submit.textContent = hasSelection ? (variant?.available === false ? 'Sold out' : 'Add to cart') : 'Select size';
    }
  };

  const initPdpMobileBuy = () => {
    if (document.querySelector('[data-nkd-mobile-buy][data-nkd-hotfix-mobile-buy]')) return;
    const page = document.querySelector('.nkd-page');
    const panel = document.querySelector('.nkd-pdp__panel');
    const productForm = panel?.querySelector('form[action*="/cart/add"]');
    if (!page || !panel || !productForm) return;

    document.querySelectorAll('[data-nkd-mobile-buy]').forEach((form) => form.remove());

    const variants = readVariants(panel);
    const title = panel.querySelector('h1')?.textContent.trim() || document.title.replace(/\s+[|-].*$/, '');
    const price = selectedPrice(panel);
    const selectedId = currentVariantId(productForm);
    const selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId)) || variants.find((variant) => variant.available) || variants[0];
    const requiresSelection = variants.length > 1;
    const mobileForm = document.createElement('form');
    mobileForm.method = 'post';
    mobileForm.action = '/cart/add';
    mobileForm.className = 'nkd-mobile-buy';
    mobileForm.setAttribute('data-nkd-mobile-buy', '');
    mobileForm.setAttribute('data-nkd-hotfix-mobile-buy', '');
    mobileForm.dataset.nkdMobileRequiresSelection = String(requiresSelection);
    mobileForm.innerHTML = `
      <input data-nkd-mobile-variant-input type="hidden" name="id" value="${requiresSelection ? '' : selectedVariant?.id || selectedId}">
      <div class="nkd-mobile-buy__meta">
        <span></span>
        <span></span>
      </div>
      ${requiresSelection ? '<button class="nkd-mobile-buy__picker" type="button" data-nkd-mobile-size-toggle>Select size</button>' : ''}
      ${requiresSelection ? '<div class="nkd-mobile-buy__label" data-nkd-mobile-label>Select size</div>' : ''}
      ${requiresSelection ? '<div class="nkd-mobile-buy__sizes" aria-label="Choose size"></div>' : ''}
      <button class="nkd-mobile-buy__submit" type="submit" ${requiresSelection ? 'disabled' : ''}>${requiresSelection ? 'Select size' : 'Add to cart'}</button>
    `;

    const meta = mobileForm.querySelectorAll('.nkd-mobile-buy__meta span');
    if (meta[0]) meta[0].textContent = title;
    if (meta[1]) meta[1].textContent = price;

    const sizes = mobileForm.querySelector('.nkd-mobile-buy__sizes');
    if (sizes && variants.length) {
      variants.forEach((variant) => {
        const button = document.createElement('button');
        button.className = 'nkd-size-chip';
        button.type = 'button';
        button.dataset.nkdMobileVariantId = variant.id;
        button.textContent = variant.title;
        if (variant.available === false) button.disabled = true;
        sizes.appendChild(button);
      });
    }

    mobileForm.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-nkd-mobile-size-toggle]');
      if (toggle) {
        event.preventDefault();
        openMobileBuy(mobileForm, selectedVariant);
        return;
      }

      const option = event.target.closest('[data-nkd-mobile-variant-id]');
      if (!option) return;
      event.preventDefault();
      const variant = variants.find((item) => String(item.id) === option.dataset.nkdMobileVariantId);
      if (!variant) return;
      updateMobileBuy(mobileForm, variant, true);
    });

    page.appendChild(mobileForm);

    if (!requiresSelection && selectedVariant) {
      updateMobileBuy(mobileForm, selectedVariant, true);
    }
  };

  ready(() => {
    initHeaderScroll();
    initTopline();
    initPdpMobileBuy();
    window.setTimeout(initPdpMobileBuy, 300);
  });
})();
